import { useIndustry } from "../../context/IndustryContext";
import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Sidebar() {
const { industry, setIndustry } =
useIndustry();
const { t } = useTranslation();

const role = "Administrator";

// Teacher
// Counselor
// SecurityOfficer
// Administrator
// Principal

const menuItems = [

{
name: t("nav.dashboard"),
path: "/ai-command-center/dashboard",
roles: [
"Principal",
"Teacher",
"Counselor",
"SecurityOfficer",
"Administrator"
]
},

{
name: t("nav.aiOperations"),
path: "/ai-command-center/ai-operations",
roles: [
"Principal",
"Administrator"
]
},

{
name: t("nav.threatZones"),
path: "/ai-command-center/threat-zones",
roles: [
"Principal",
"SecurityOfficer",
"Administrator"
]
},

{
name: t("nav.forecasting"),
path: "/ai-command-center/forecasting",
roles: [
"Principal",
"Administrator"
]
},

{
name: t("nav.governance"),
path: "/ai-command-center/governance",
roles: [
"Principal",
"Administrator"
]
},

{
name: t("nav.missionControl"),
path: "/ai-command-center/mission-control",
roles: [
"Principal",
"SecurityOfficer",
"Administrator"
]
},

{
name: t("nav.telemetry"),
path: "/ai-command-center/telemetry",
roles: [
"Principal",
"Administrator"
]
},

{
name: t("nav.incidentArchive"),
path: "/ai-command-center/incident-archive",
roles: [
"Principal",
"Counselor",
"Administrator"
]
},

{
name: t("nav.researchValidation"),
path: "/ai-command-center/research-validation",
roles: [
"Principal",
"Administrator"
]
}

];

const itemStyle = {
display: "block",
padding: "14px 18px",
borderRadius: "10px",
marginBottom: "10px",
fontWeight: "500",
transition: "0.2s"
};

const activeStyle = {
background: "linear-gradient(90deg,#2563eb,#1d4ed8)",
color: "white",
boxShadow: "0 0 18px rgba(37,99,235,.7)",
borderLeft: "4px solid #93c5fd"
};

const inactiveStyle = {
color: "#cbd5e1"
};

return (

<div
style={{
width: "260px",
background: "#0f172a",
minHeight: "100vh",
padding: "20px",
borderRight: "1px solid #1e293b",
position: "fixed",
left: 0,
top: 0
}}
>

<h2
style={{
color: "white",
marginBottom: "10px"
}}
>
FentaSafe
</h2>

<div
style={{
fontSize: "12px",
color: "#94a3b8",
marginBottom: "25px"
}}
>
Role: {role}
<select
value={industry}
onChange={(e) =>
  setIndustry(e.target.value)
}
style={{
width: "100%",
padding: "10px",
marginBottom: "20px",
background: "#111827",
color: "white",
border: "1px solid #1e293b",
borderRadius: "8px"
}}
>

<option>School</option>
<option>Airport</option>
<option>Public Event</option>
<option>Border Security</option>
<option>Military</option>

</select>

<div
style={{
fontSize: "12px",
color: "#94a3b8",
marginBottom: "20px"
}}
>
Industry: {industry}
</div>
</div>

{menuItems
.filter(item => item.roles.includes(role))
.map(item => (

<NavLink
key={item.path}
to={item.path}
style={({ isActive }) => ({
display: "block",
textDecoration: "none",
...itemStyle,
...(isActive ? activeStyle : inactiveStyle)
})}
>
{item.name}
</NavLink>

))}

</div>

);

}

export default Sidebar;